import http from "@/http";
// ### 获取日志
// http://base.leubao.com/api/log/list
export const getLogList = {
  p: "/api/log/list",
  r: data => {
    return http({
      url: "/api/log/list",
      method: "post",
      data
    });
  }
};
